(function () {
  const ROOT_SELECTOR = '[data-featured-collection-tabs]';

  function initRoot(root) {
    if (!root || root.dataset.fctInit === 'true') return;

    const tabs = Array.from(root.querySelectorAll('[data-fct-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-fct-panel]'));

    if (!panels.length) return;

    root.dataset.fctInit = 'true';

    const prevBtn = root.querySelector('[data-fct-prev]');
    const nextBtn = root.querySelector('[data-fct-next]');
    const viewAll = root.querySelector('[data-fct-viewall]');

    let activeIndex = 0;

    function sliderElOf(panel) {
      return panel ? panel.querySelector('[data-fct-slider]') : null;
    }

    let bleed = 0;

    // The slider bleeds to both screen edges. CSS can only guess the bleed with 100vw,
    // which counts the scrollbar and pushes the last card past the visible edge, so measure it.
    function updateBleed() {
      const panel = panels[activeIndex] || panels[0];

      if (!panel) return;

      const contentWidth = panel.getBoundingClientRect().width;
      const viewportWidth = document.documentElement.clientWidth;

      bleed = Math.max(0, Math.floor((viewportWidth - contentWidth) / 2));

      root.style.setProperty('--fct-bleed', bleed + 'px');
    }

    // Cards bleed off the screen edge while scrolling, but the last slide stops on the
    // page-width line instead of hard against the viewport edge.
    // update() snaps back to the last settled slide, so calling it mid-swipe throws the
    // slider back to the start. Only run it when the offset changed (or when forced).
    function applyEndOffset(instance, force) {
      if (!instance) return;
      if (!force && instance.params.slidesOffsetAfter === bleed) return;

      instance.params.slidesOffsetAfter = bleed;
      instance.update();
    }

    function swiperOf(panel) {
      const sliderEl = sliderElOf(panel);

      if (!sliderEl) return null;
      if (sliderEl.fctSwiper) return sliderEl.fctSwiper;
      if (typeof Swiper === 'undefined') return null;

      let options = {};

      try {
        options = JSON.parse(sliderEl.dataset.sliderOptions || '{}');
      } catch (error) {
        console.warn('Featured collection tabs: options parse error', error);
      }

      options.slidesOffsetAfter = bleed;
      // Swiper's own resize handling also fires on height changes (lazy images, review
      // stars loading in) and snaps back to the last settled slide, which throws a swipe
      // back to the first card. Resizing is handled below, on width changes only.
      options.resizeObserver = false;
      options.updateOnWindowResize = false;

      const instance = new Swiper(sliderEl, options);

      sliderEl.fctSwiper = instance;

      // Swiper 11 bug: a drag that starts on a focusable element (the add to cart button)
      // skips the step that records where the drag began, so it reuses the previous drag's
      // start point and the slider jumps back (often to the first card). Record it here.
      instance.on('touchStart', function () {
        instance.touchEventsData.startTranslate = instance.getTranslate();
      });

      instance.on('slideChange', syncNav);
      instance.on('resize', syncNav);
      instance.on('observerUpdate', syncNav);

      if (sliderEl.hasAttribute('data-fct-wheel')) bindWheel(sliderEl, instance);
      if (instance.scrollbar && instance.scrollbar.el) bindScrollbarFlash(sliderEl, instance);

      return instance;
    }

    // Touch screens have no hover, so the scrollbar shows while a swipe (and its momentum
    // glide) is running and fades out once the row settles, like a native scroll indicator.
    function bindScrollbarFlash(sliderEl, instance) {
      const wrapper = sliderEl.parentElement;
      let hideTimer = null;

      function hide(delay) {
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function () {
          if (instance.animating) {
            hide(300);
            return;
          }

          wrapper.classList.remove('fct-scrolling');
        }, delay);
      }

      instance.on('touchStart', function () {
        clearTimeout(hideTimer);
        wrapper.classList.add('fct-scrolling');
      });
      instance.on('touchEnd', function () {
        hide(800);
      });
      instance.on('destroy', function () {
        clearTimeout(hideTimer);
      });
    }

    // Hovering a row and turning the mouse wheel (or swiping a trackpad) scrolls it sideways.
    // Swiper's own mousewheel module moves a whole wheel notch (~100px) in one jump, so the
    // wheel sets a target here and the row eases towards it. At either end the wheel is let
    // through, so the page carries on scrolling instead of getting stuck on the row.
    function bindWheel(sliderEl, instance) {
      let target = null;
      let frame = null;

      function stop() {
        if (frame) cancelAnimationFrame(frame);
        frame = null;
        target = null;
      }

      function moveTo(position) {
        instance.setTranslate(position);
        instance.updateActiveIndex();
        instance.updateSlidesClasses();
        syncNav();
      }

      function step() {
        const diff = target - instance.translate;

        if (Math.abs(diff) < 0.5) {
          moveTo(target);
          stop();
          return;
        }

        moveTo(instance.translate + diff * 0.18);
        frame = requestAnimationFrame(step);
      }

      sliderEl.addEventListener(
        'wheel',
        function (event) {
          if (instance.destroyed || instance.isLocked || instance.params.loop || event.ctrlKey) return;

          let delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;

          if (event.deltaMode === 1) delta *= 16;
          if (event.deltaMode === 2) delta *= sliderEl.clientWidth;
          if (!delta) return;

          // Translate runs from minTranslate (first card) down to maxTranslate (last card).
          const start = instance.minTranslate();
          const end = instance.maxTranslate();

          const from = target === null ? instance.getTranslate() : target;

          if ((delta < 0 && from >= start) || (delta > 0 && from <= end)) return;

          event.preventDefault();

          if (target === null) {
            // Halt any free mode momentum glide where it is before taking over.
            instance.setTransition(0);
            instance.setTranslate(from);
            instance.animating = false;
          }

          target = Math.min(start, Math.max(end, from - delta));

          if (!frame) frame = requestAnimationFrame(step);
        },
        { passive: false }
      );

      instance.on('touchStart', stop);
      instance.on('destroy', stop);
    }

    function currentSwiper() {
      const sliderEl = sliderElOf(panels[activeIndex]);
      return sliderEl && sliderEl.fctSwiper ? sliderEl.fctSwiper : null;
    }

    function syncNav() {
      if (!prevBtn || !nextBtn) return;

      const instance = currentSwiper();


if (!instance) {
  const sliderEl = sliderElOf(panels[activeIndex]);
  const nativeMobile =
    tabs.length > 1 &&
    window.matchMedia('(max-width: 749px)').matches &&
    sliderEl;

  if (nativeMobile) {
    prevBtn.disabled = sliderEl.scrollLeft <= 2;
    nextBtn.disabled =
      sliderEl.scrollLeft + sliderEl.clientWidth >= sliderEl.scrollWidth - 2;
  } else {
    prevBtn.disabled = true;
    nextBtn.disabled = true;
  }
  return;
}


      if (instance.params.loop) {
        prevBtn.disabled = false;
        nextBtn.disabled = false;
        return;
      }

      prevBtn.disabled = instance.isBeginning;
      nextBtn.disabled = instance.isEnd;
    }

    function pauseHiddenAutoplay() {
      panels.forEach(function (panel, index) {
        const sliderEl = sliderElOf(panel);
        const instance = sliderEl ? sliderEl.fctSwiper : null;

        if (!instance || !instance.autoplay) return;

        if (index === activeIndex) {
          if (instance.params.autoplay && instance.params.autoplay.enabled) instance.autoplay.start();
        } else {
          instance.autoplay.stop();
        }
      });
    }

    // On mobile the tab row scrolls sideways, so a tab near the edge can be cut off.
    // Scroll the row (never the page) to centre the selected tab; the browser clamps at either end.
    function revealTab(tab, smooth) {
      const row = tab.parentElement;

      if (!row || row.scrollWidth <= row.clientWidth) return;

      const rowRect = row.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();
      const delta = tabRect.left + tabRect.width / 2 - (rowRect.left + rowRect.width / 2);

      if (Math.abs(delta) > 1) row.scrollBy({ left: delta, behavior: smooth ? 'smooth' : 'auto' });
    }

    function activate(index, focusTab, smooth) {
      if (index < 0 || index >= panels.length) return;

      activeIndex = index;

      tabs.forEach(function (tab, i) {
        const isSelected = i === index;

        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');

        if (isSelected && focusTab) tab.focus({ preventScroll: true });
        if (isSelected) revealTab(tab, smooth);
      });

      panels.forEach(function (panel, i) {
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      updateBleed();

      const instance = swiperOf(panels[index]);

      // The panel was display:none while hidden, so re-measure it now it is visible.
      applyEndOffset(instance, true);

      if (viewAll) {
        const url = panels[index].dataset.fctViewallUrl;
        if (url) viewAll.setAttribute('href', url);
      }

      pauseHiddenAutoplay();
      syncNav();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(index, false, true);
      });

      tab.addEventListener('keydown', function (event) {
        let target = null;

        if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = tabs.length - 1;

        if (target === null) return;

        event.preventDefault();
        activate(target, true, true);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        const instance = currentSwiper();
if (instance) instance.slidePrev();
else if (tabs.length > 1 && window.matchMedia('(max-width: 749px)').matches) {
  sliderElOf(panels[activeIndex])?.scrollBy({
    left: -300,
    behavior: 'smooth'
  });
}
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        const instance = currentSwiper();
       if (instance) instance.slideNext();
else if (tabs.length > 1 && window.matchMedia('(max-width: 749px)').matches) {
  sliderElOf(panels[activeIndex])?.scrollBy({
    left: 300,
    behavior: 'smooth'
  });
}
      });
    }

    let resizeTimer = null;
    let lastViewportWidth = document.documentElement.clientWidth;
    let lastRootWidth = root.getBoundingClientRect().width;

    function isInteracting(instance) {
      return instance && (instance.animating || (instance.touchEventsData && instance.touchEventsData.isTouched));
    }

    // update() snaps to the last settled slide, so never run it while a swipe or slide
    // transition is in progress; wait for it to finish instead.
    function refresh() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        const instance = currentSwiper();

        if (isInteracting(instance)) {
          refresh();
          return;
        }

        updateBleed();
        applyEndOffset(instance, true);
        syncNav();
      }, 150);
    }

    // Mobile browsers fire resize when the address bar shows or hides during a page
    // scroll. Only the width matters here, so ignore height-only resizes.
    root.fctResize = function () {
      const viewportWidth = document.documentElement.clientWidth;
      const rootWidth = root.getBoundingClientRect().width;

      if (viewportWidth === lastViewportWidth && rootWidth === lastRootWidth) return;

      lastViewportWidth = viewportWidth;
      lastRootWidth = rootWidth;
      refresh();
    };

    window.addEventListener('resize', root.fctResize);

    if (typeof ResizeObserver !== 'undefined') {
      root.fctResizeObserver = new ResizeObserver(root.fctResize);
      root.fctResizeObserver.observe(root);
    }

    const initialIndex = tabs.findIndex(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    });

    activate(initialIndex > -1 ? initialIndex : 0, false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  function destroyAll(scope) {
    if (!scope) return;

    scope.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (root.fctResize) {
        window.removeEventListener('resize', root.fctResize);
        root.fctResize = null;
      }

      if (root.fctResizeObserver) {
        root.fctResizeObserver.disconnect();
        root.fctResizeObserver = null;
      }

      root.querySelectorAll('[data-fct-slider]').forEach(function (sliderEl) {
        if (sliderEl.fctSwiper) {
          sliderEl.fctSwiper.destroy(true, true);
          sliderEl.fctSwiper = null;
        }
      });

      delete root.dataset.fctInit;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const tab = event.target.matches('[data-fct-tab]') ? event.target : event.target.querySelector('[data-fct-tab]');

    if (tab) tab.click();
  });
})();
